"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanCodeSendPoints = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var mall_1 = require("../../model/mall");
var service_1 = require("../../../library/base/service");
var ScanCodeSendPoints = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ScanCodeSendPoints, _super);
    function ScanCodeSendPoints() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分充值';
        _this.code = '101175';
        _this.desc = '积分充值';
        _this.requestParams = new mall_1.ScanCodeSendPointsRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ScanCodeSendPoints;
}(service_1.BaseService));
exports.ScanCodeSendPoints = ScanCodeSendPoints;
//# sourceMappingURL=scanCodeSendPoints.js.map